import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { formatDate } from "../../../../utils/dateUtils";


function ListadoFacturas() {
  const { user } = useContext(AuthContext);
  const URL_FACTURAS = import.meta.env.VITE_URL_FACTURAS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const URL_TIMBRAR = import.meta.env.VITE_URL_TIMBRAR;
  const URL_VENTAS_TIENDAS = import.meta.env.VITE_URL_VENTAS_TIENDAS;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);
  
  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");



  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState("");
  const [surtidos, setSurtidos] = useState([]);



  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // Candado de doble clic para reintentar/corregir/cancelar: dos clics con
  // milisegundos de diferencia disparaban dos timbrados y duplicaban CFDIs en
  // el SAT (esta pantalla no tenía ningún guard). Se libera al terminar cada
  // acción; en los caminos que recargan la página el reload lo limpia solo.
  const procesandoRef = useRef(false);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
    .get(`${URL_FACTURAS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allFacturas = response.data;
        // Array para pagination
        let arrayTabla = allFacturas
          .sort((a, b) => (a.idFactura < b.idFactura ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              is_active: a.is_active,
              fecha: a.fecha,
              idFactura: a.idFactura,
              folio: a.folio,
              serie: a.serie,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              vendedores: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
              total: a.timbre === "No" ? 0 : a.total,
              idFacturama: a.idFacturama,
              timbre: a.timbre,
              subTotal: a.timbre === "No" ? 0 : a.subTotal,
              iva: a.timbre === "No" ? 0 : a.iva,
              descuentoNumero1: a.descuentoNumero1,
              descuentoNumero2: a.descuentoNumero2,
              cadenaSAT: a.cadenaSAT,
              observaciones: a.observaciones,
              // Datos necesarios para diagnosticar y reintentar una factura que NO se timbró.
              // Sin esto la fila queda muda: ni PDF (no existe) ni forma de saber por qué falló.
              respuestaFacturama: a.respuestaFacturama,
              formaPagoSATCliente: a.formaPagoSATCliente,
              metodoPagoSATCliente: a.metodoPagoSATCliente,
              usoCFDICliente: a.usoCFDICliente,
              // Datos del receptor GUARDADOS en la factura (snapshot al momento de crearla).
              // Se comparan contra el catálogo de Clientes actual para poder resincronizarlos
              // si el catálogo se corrigió después (typos, RFC actualizado, etc.).
              rfcCliente: a.rfcCliente,
              nombreCliente: a.nombreCliente,
              regFiscalCliente: a.regFiscalCliente,
              cpCliente: a.cpCliente,
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  let totalImportePDF = 0;
  let subTotalPDF = 0;
  let totalIVAPDF = 0;

  function PDFTabla() {
    const data = comments
    .sort((a, b) => (a.folio > b.folio ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (a.folio != 0)
      ) {
        if(a.is_active == "Si"){
        totalImportePDF = totalImportePDF + a.total;
        subTotalPDF = subTotalPDF + a.subTotal;
        totalIVAPDF = totalIVAPDF + a.iva;
        return [
          a.serie + a.folio,
          // a.numeroFactura,
          a.fecha,
          a.clientes,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total),
          // a.user,
        ]
      }else {
        return [
          a.serie + a.folio,
          // a.numeroFactura,
          a.fecha,
          a.clientes,
          "",
          "Cancelada",
          "",
          // a.user,
        ]
      }
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["No.", "Fecha", "Cliente", "SubTotal", "IVA", "Total"]],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          // "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVAPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImportePDF),

        ]
      ],
      showFoot: "lastPage",
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        if(a.is_active == "Si"){
        return {
          Numero: a.idFactura,
          // Factura: a.numeroFactura,
          Fecha: a.fecha,
          Cliente: a.clientes,
          SubTotal: a.subTotal,
          IVA: a.iva,
          Total: a.total,
          // Surtio: a.user,
        }
        }else{
          return {
            Numero: a.idFactura,
            // Factura: a.numeroFactura,
            Fecha: a.fecha,
            Cliente: a.clientes,
            SubTotal: 0,
            IVA: 0,
            Total: 0,
            // Surtio: a.user,
          }
        }
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoFacturas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoFacturas",
        sheetFilter: ["Numero", "Fecha", "Cliente", "SubTotal", "IVA", "Total"],
        sheetHeader: ["Numero", "Fecha", "Cliente", "SubTotal", "IVA", "Total"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        if(a.is_active == "Si"){
        totalImportePDF = totalImportePDF + a.total;
        subTotalPDF = subTotalPDF + a.subTotal;
        totalIVAPDF = totalIVAPDF + a.iva;
        return [
          a.idFactura,
          // a.numeroFactura,
          a.fecha,
          a.clientes,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total),
          // a.user,
        ]
      }else {
        return [
          a.idFactura,
          // a.numeroFactura,
          a.fecha,
          a.clientes,
          "",
          "Cancelada",
          "",
          // a.user,
        ]
      }
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["No.", "Fecha", "Cliente", "SubTotal", "IVA", "Total"]],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          // "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVAPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImportePDF),

        ]
      ]
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Facturas",
          email: mailTo,
          fileName: "ListadoFacturas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Facturas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }


  // --- Facturas que NO se timbraron -----------------------------------------
  // Una factura con timbre="No" dejaba la fila sin ningún botón: sin PDF (no existe),
  // sin manera de reintentar y sin manera de saber por qué falló. Además el ticket queda
  // ligado a ella (facturado="Si"), así que tampoco reaparece en el selector de facturación.
  const textoErrorFacturama = (resp) => {
    const o = Array.isArray(resp) ? resp[resp.length - 1] : resp;
    if (!o) return "";
    if (typeof o === "string") return o;
    if (o.ModelState) return Object.values(o.ModelState).flat().join(" ");
    return o.Message || o.message || o.error || "";
  };

  const detalleError = (error) => {
    const d = error?.response?.data;
    if (!d) return error?.message || String(error);
    if (typeof d === "string") return d;
    if (Array.isArray(d.errores) && d.errores.length) return d.errores.join(" ");
    if (d.ModelState) return Object.values(d.ModelState).flat().join(" ");
    return d.message || d.Message || d.error || error?.message || JSON.stringify(d);
  };

  // Una misma factura puede venir de un surtido (fiscal) o de una venta de tienda,
  // y cada una se timbra con un endpoint distinto. Se resuelve preguntando si hay
  // ventas de tienda ligadas a la factura.
  async function endpointTimbrado(idFactura) {
    try {
      const res = await axios.get(`${URL_VENTAS_TIENDAS}Factura/${idFactura}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const ventas = res.data;
      if (Array.isArray(ventas) && ventas.length > 0) return `${URL_TIMBRAR}FacturaVentaTienda`;
      return `${URL_TIMBRAR}Factura`;
    } catch (e) {
      // Si no se puede determinar, NO se adivina: timbrar con el endpoint equivocado
      // manda a Facturama un CFDI sin conceptos.
      console.warn("No se pudo determinar el origen de la factura:", e);
      return null;
    }
  }

  // Wrapper con candado de doble clic para el botón "Reintentar el timbrado".
  // La lógica real vive en ejecutarReintentoTimbrado para que corregirYReintentar
  // (que ya tomó el candado) pueda llamarla sin que el guard la bloquee.
  async function reintentarTimbrado(a) {
    if (procesandoRef.current) return;
    procesandoRef.current = true;
    try {
      await ejecutarReintentoTimbrado(a);
    } finally {
      procesandoRef.current = false;
    }
  }

  async function ejecutarReintentoTimbrado(a) {
    const url = await endpointTimbrado(a._id);
    if (!url) {
      Swal.fire({
        icon: "error",
        title: "No se pudo reintentar",
        text: "No se pudo determinar el origen de la factura (surtido o venta de tienda). Intente de nuevo.",
      });
      return;
    }
    showLoader();
    try {
      await axios.post(
        url,
        { facturas: a._id },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      await axios.post(
        URL_LOGS,
        {
          tipo: "Reintentar Timbrado",
          detalle: `Reintento timbrado factura ${a.serie}-${a.folio} (${a._id})`,
          user: user.id,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      hideLoader();
      await Swal.fire({ icon: "success", title: "Timbrada", text: `Se timbró la factura ${a.serie}-${a.folio}` });
      window.location.reload();
    } catch (error) {
      hideLoader();
      const detalle = detalleError(error);
      if (error?.response?.status === 409) {
        await Swal.fire({
          icon: "info",
          title: "Ya estaba timbrada",
          text: "Esta factura ya había sido timbrada. No se generó un duplicado.",
        });
        window.location.reload();
        return;
      }
      Swal.fire({
        icon: "error",
        title: "Sigue sin timbrar",
        html:
          `<div style="text-align:left">${detalle}</div>` +
          `<br/><div style="text-align:left">Use <b>Corregir y reintentar</b> para arreglar el dato que rechaza el SAT.</div>`,
      });
      console.log(error);
    }
  }

  // El reintento re-envía a Facturama los datos GUARDADOS en la factura
  // (PaymentForm: fac.formaPagoSATCliente), no los del cliente ni los de la pantalla.
  // Por eso, si la factura se guardó con un dato inválido, reintentar solo repite el error:
  // hay que corregir la factura misma antes de volver a timbrar.
  //
  // Caso frecuente (N-????): rfcCliente/nombreCliente se copian del catálogo de Clientes
  // SOLO al crear la factura y quedan congelados en el documento. Si el catálogo se
  // corrige después (typo, RFC actualizado), la factura ya creada sigue enviando el dato
  // viejo y el SAT la rechaza con "Nombre del receptor...", aunque el cliente ya esté bien.
  // Por eso se compara contra el catálogo y se ofrece resincronizar antes de reintentar.
  async function corregirYReintentar(a) {
    if (procesandoRef.current) return;
    procesandoRef.current = true;
    try {
      await ejecutarCorreccionYReintento(a);
    } finally {
      procesandoRef.current = false;
    }
  }

  async function ejecutarCorreccionYReintento(a) {
    const formasPago = [
      ["01", "01 Efectivo"], ["02", "02 Cheque nominativo"],
      ["03", "03 Transferencia electrónica de fondos"], ["04", "04 Tarjeta de crédito"],
      ["05", "05 Monedero electrónico"], ["06", "06 Dinero electrónico"],
      ["08", "08 Vales de despensa"], ["12", "12 Dación en pago"],
      ["13", "13 Pago por subrogación"], ["14", "14 Pago por consignación"],
      ["15", "15 Condonación"], ["17", "17 Compensación"], ["23", "23 Novación"],
      ["24", "24 Confusión"], ["25", "25 Remisión de deuda"],
      ["26", "26 Prescripción o caducidad"], ["27", "27 A satisfacción del acreedor"],
      ["28", "28 Tarjeta de débito"], ["29", "29 Tarjeta de servicios"],
      ["30", "30 Aplicación de anticipos"], ["99", "99 Por definir"],
    ];
    const usosCFDI = [
      ["G01", "G01 Adquisición de mercancías"],
      ["G03", "G03 Gastos en general"],
      ["S01", "S01 Sin efectos fiscales"],
    ];
    const opciones = (lista, actual) =>
      lista.map(([v, t]) => `<option value="${v}" ${v === actual ? "selected" : ""}>${t}</option>`).join("");

    const cliente = clientes.find((c) => c._id === a.idClientes);
    const desfaseCatalogo =
      !!cliente &&
      (String(cliente.RFC || "") !== String(a.rfcCliente || "") ||
        String(cliente.razon_social || "") !== String(a.nombreCliente || "") ||
        String(cliente.regFiscal || "") !== String(a.regFiscalCliente || "") ||
        String(cliente.cp || "") !== String(a.cpCliente || ""));

    const motivo = textoErrorFacturama(a.respuestaFacturama);
    const { isConfirmed, value } = await Swal.fire({
      title: `Corregir factura ${a.serie}-${a.folio}`,
      html:
        (motivo ? `<div style="text-align:left"><b>El SAT rechazó por:</b><br/>${motivo}</div><br/>` : "") +
        (desfaseCatalogo
          ? `<div style="text-align:left;background:#fff3cd;border:1px solid #ffe69c;border-radius:6px;padding:8px;margin-bottom:10px;font-size:0.85em">
               <b>⚠ Esta factura no coincide con el catálogo de Clientes actual:</b><br/>
               <table style="width:100%"><tr><th></th><th>Guardado en la factura</th><th>Catálogo actual</th></tr>
               <tr><td>Nombre</td><td>${a.nombreCliente || "(vacío)"}</td><td>${cliente.razon_social || "(vacío)"}</td></tr>
               <tr><td>RFC</td><td>${a.rfcCliente || "(vacío)"}</td><td>${cliente.RFC || "(vacío)"}</td></tr>
               <tr><td>Régimen</td><td>${a.regFiscalCliente || "(vacío)"}</td><td>${cliente.regFiscal || "(vacío)"}</td></tr>
               <tr><td>CP</td><td>${a.cpCliente || "(vacío)"}</td><td>${cliente.cp || "(vacío)"}</td></tr>
               </table>
               <label style="display:block;margin-top:6px">
                 <input type="checkbox" id="swal-resync" checked /> Actualizar esta factura con los datos ACTUALES del catálogo
               </label>
             </div>`
          : "") +
        `<div style="text-align:left">
           <label>Forma de Pago</label>
           <select id="swal-forma" class="swal2-input" style="width:100%">${opciones(formasPago, a.formaPagoSATCliente)}</select>
           <label>Método de Pago</label>
           <select id="swal-metodo" class="swal2-input" style="width:100%">
             <option value="PUE" ${a.metodoPagoSATCliente === "PUE" ? "selected" : ""}>PUE (Pago en Una Sola Exhibición)</option>
             <option value="PPD" ${a.metodoPagoSATCliente === "PPD" ? "selected" : ""}>PPD (Pago en Parcialidades o Diferido)</option>
           </select>
           <label>Uso de CFDI</label>
           <select id="swal-uso" class="swal2-input" style="width:100%">${opciones(usosCFDI, a.usoCFDICliente)}</select>
         </div>
         <br/><div style="text-align:left;font-size:0.9em">Se corrige <b>esta factura</b> y se reintenta el timbrado con el mismo folio. Si el dato también está mal en el cliente, corríjalo en <b>Catálogos → Clientes</b> para que no vuelva a pasar.</div>`,
      showCancelButton: true,
      confirmButtonText: "Guardar y reintentar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      preConfirm: () => {
        const forma = document.getElementById("swal-forma").value;
        const metodo = document.getElementById("swal-metodo").value;
        const uso = document.getElementById("swal-uso").value;
        const resync = desfaseCatalogo ? document.getElementById("swal-resync").checked : false;
        if (metodo === "PUE" && forma === "99") {
          Swal.showValidationMessage("Con PUE el SAT no acepta la forma de pago 99 (Por definir).");
          return false;
        }
        if (metodo === "PPD" && forma !== "99") {
          Swal.showValidationMessage("Con PPD la forma de pago debe ser 99 (Por definir).");
          return false;
        }
        return { forma, metodo, uso, resync };
      },
    });
    if (!isConfirmed || !value) return;

    const patchBody = {
      formaPagoSATCliente: value.forma,
      metodoPagoSATCliente: value.metodo,
      usoCFDICliente: value.uso,
    };
    if (value.resync && cliente) {
      patchBody.rfcCliente = cliente.RFC;
      patchBody.nombreCliente = cliente.razon_social;
      patchBody.regFiscalCliente = String(cliente.regFiscal);
      patchBody.cpCliente = String(cliente.cp);
    }

    showLoader();
    try {
      await axios.patch(`${URL_FACTURAS}/${a._id}`, patchBody, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      await axios.post(
        URL_LOGS,
        {
          tipo: "Corregir Factura",
          detalle:
            `Factura ${a.serie}-${a.folio}: formaPago ${a.formaPagoSATCliente}→${value.forma}, metodoPago ${a.metodoPagoSATCliente}→${value.metodo}, usoCFDI ${a.usoCFDICliente}→${value.uso}` +
            (value.resync && cliente
              ? `, resincronizado con catálogo (nombreCliente "${a.nombreCliente}"→"${cliente.razon_social}", rfcCliente "${a.rfcCliente}"→"${cliente.RFC}")`
              : ""),
          user: user.id,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      hideLoader();
    } catch (error) {
      hideLoader();
      Swal.fire({ icon: "error", title: "No se pudo corregir la factura", text: detalleError(error) });
      console.log(error);
      return;
    }

    await ejecutarReintentoTimbrado({ ...a, ...patchBody });
  }

  async function PDFOC(
    idFacturama,
    serie,
    folio
  ) {
    await axios
      .get(`${URL_TIMBRAR}ObtenerPDF/${idFacturama}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let facturaBase64 = response.data.respuesta.Content;
        
        const binaryData = atob(facturaBase64);
        
        const uint8Array = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }
        
        const blob = new Blob([uint8Array], { type: "application/pdf" });
        
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Factura${serie}-${folio}.pdf`;
        
        a.click();
        
        URL.revokeObjectURL(url);
        
        
      })
      .catch((err) => {
        console.log(err);
      });
  }
  
  async function PDFOCXML(
    idFacturama,
    serie,
    folio
  ) {
    await axios
      .get(`${URL_TIMBRAR}ObtenerXML/${idFacturama}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
      const facturaXMLBase64 = response.data.respuesta.Content;

      const facturaBlob = b64toBlob(facturaXMLBase64, 'application/xml');

      const dataURL = URL.createObjectURL(facturaBlob);

      const a = document.createElement('a');
      a.href = dataURL;
      a.download = `Factura${serie}-${folio}.xml`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      function b64toBlob(base64, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
      }

        
      })
      .catch((err) => {
        console.log(err);
      });
  }
  
  async function PDFOCXMLCANCELADA(
    id,
    serie,
    folio
  ) {
    await axios
      .get(`${URL_FACTURAS}/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let facturaXMLBase64 = response.data.respuestaFacturamaCancel[0].AcuseXmlBase64
        
      const facturaBlob = b64toBlob(facturaXMLBase64, 'application/xml');

      const dataURL = URL.createObjectURL(facturaBlob);

      const a = document.createElement('a');
      a.href = dataURL;
      a.download = `Factura${serie}-${folio}.xml`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      function b64toBlob(base64, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
      }

        
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headers = [
    { name: "Numero", field: "idFactura", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "vendedores", sortable: true },
    { name: "Folio", field: "folio", sortable: true },
    { name: "SubTotal", field: "subTotal", sortable: true },
    { name: "iva", field: "iva", sortable: true },
    { name: "Total", field: "total", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: false },
    { name: "Timbre", field: "timbre", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedores.toLowerCase().includes(search.toLowerCase()) ||
          comment.timbre.toLowerCase().includes(search.toLowerCase()) ||
          comment.folio.toString().includes(search) ||
          comment.subTotal.toString().includes(search) ||
          comment.iva.toString().includes(search) ||
          comment.total.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "folio"  &&
      sorting.field != "subTotal" &&
      sorting.field != "iva" &&
      sorting.field != "total"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "folio"  ||
      sorting.field == "subTotal"||
      sorting.field == "iva"||
      sorting.field == "total")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "folio"  ||
      sorting.field == "subTotal"||
      sorting.field == "iva"||
      sorting.field == "total")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  function cancelarFactura(id, idFacturama, clientes, total) {
    // Doble clic aquí mandaría dos cancelaciones a Facturama y aplicaría dos
    // veces los ajustes de saldo del cliente.
    if (procesandoRef.current) return;
    procesandoRef.current = true;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara la Factura!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {

      toggleProgreso();
    axios
      .patch(`${URL_TIMBRAR}CancelFactura/${id}/${idFacturama}`,
      {
        clientes,
        total
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        procesandoRef.current = false;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
    } else {
      procesandoRef.current = false;
    }
  });
  }



  return (
    <>
      <Header />
      <br />
      <br />
      {user.facturasFiscal ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
            <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/FacturasCreate"
                >
                  Nueva Factura
                </Button>
              <Button
                size="sm"
                href="/MenuFiscal"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Facturas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Facturas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                if(a.is_active == "No"){
                  return (
                    <tr className="row-cancelled">
                      <td>{a.idFactura}</td>
                      <td>{formatDate(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.vendedores}</td>
                      <td>{a.serie} {a.folio}</td>
                      <td></td>
                      <td></td>
                      <td>CANCELADA</td>
                      <td></td>
                      <td></td>
                      <td>
                      <>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.idFacturama,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                      <Button
                              size="sm"
                              className="btn"
                              color="info"
                              onClick={(e) =>
                                PDFOCXMLCANCELADA(
                                  a._id,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                            <i class="fas fa-file-alt"></i>
                            </Button>
                      </>
                      </td>
                    </tr>
                  );
                }else{
                  // totalImporteTabla = totalImporteTabla + a.total_general;
                  // subTotalTabla = subTotalTabla + a.subTotal;
                  // totalIVATabla = totalIVATabla + a.iva;
                  return (
                    <tr>
                       <td>{a.idFactura}</td>
                      <td>{formatDate(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.vendedores}</td>
                      <td>{a.serie} {a.folio}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total)}</td>
                      <td>{a.observaciones}</td>
                      <td>
                        {a.timbre}
                        {a.timbre != "Si" && textoErrorFacturama(a.respuestaFacturama) ? (
                          <div style={{ color: "#d33", fontSize: "0.8em" }}>
                            {textoErrorFacturama(a.respuestaFacturama)}
                          </div>
                        ) : undefined}
                      </td>
                      <td>
                        {a.timbre != "Si" ? (
                          <>
                            <Button
                              size="sm"
                              className="btn"
                              color="warning"
                              title="Reintentar el timbrado con los mismos datos"
                              onClick={(e) => reintentarTimbrado(a)}
                            >
                              <i class="fas fa-redo"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              title="Corregir los datos fiscales de esta factura y reintentar"
                              onClick={(e) => corregirYReintentar(a)}
                            >
                              <i class="fas fa-wrench"></i>
                            </Button>
                          </>
                        ) : undefined}
                        {a.timbre == "Si" ? (

                          <>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.idFacturama,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="info"
                              onClick={(e) =>
                                PDFOCXML(
                                  a.idFacturama,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                              <i class="fas fa-file-alt"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => cancelarFactura(a._id, a.idFacturama, a.idClientes, a.total)}
                            >
                              <i class="fas fa-ban"></i>
                            </Button>
                          </>
                        ): undefined}
                      </td>
                    </tr>
                  );
                }

              })}
              {/* <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVATabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImporteTabla)}
                </td>
                <td></td>
              </tr> */}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>


          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

        </div>
      ) : undefined}
      <br />
      {loader}
    </>
  );
}

export default ListadoFacturas;
